export const SET_START_ROTATE = 'SET_START_ROTATE'
export const SET_WHEEL_IMAGES = 'SET_WHEEL_IMAGES'
export const INCREASE_SPIN_QUANTITY = 'INCREASE_SPIN_QUANTITY'
export const RESET_SPIN_QUANTITY = 'RESET_SPIN_QUANTITY'
export const SET_IS_EDITING = 'SET_IS_EDITING_TURNTABLE'
export const SET_HAS_SPIN_ONCE = 'SET_HAS_SPIN_ONCE'
